import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { observable, computed } from 'mobx';
import { timestampToISO } from 'utils/grpcUtil';
import { maybeParseDate } from 'utils/dateUtil';
import ScopeChangeRequestItem from './ScopeChangeRequestItem';
import { JobScopeChangeStatus, JobScopeInventoryItemType as JobScopeInventoryItemTypeProto } from '@taxfyle/api-internal/internal/job_scope_change_pb';
export var ScopeChangeStatus = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, JobScopeChangeStatus.PENDING_FINALIZATION, 'PendingFinalization'), JobScopeChangeStatus.PENDING_ADMIN_APPROVAL, 'PendingAdminApproval'), JobScopeChangeStatus.PENDING_CLIENT_APPROVAL, 'PendingClientApproval'), JobScopeChangeStatus.ACCEPTED, 'Accepted'), JobScopeChangeStatus.REJECTED, 'Rejected'), JobScopeChangeStatus.APPLY_FAILED, 'ApplyFailed');
export var JobScopeInventoryItemType = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, JobScopeInventoryItemTypeProto.JOB_SCOPE_INVENTORY_ITEM_TYPE_UNSPECIFIED, 'Unspecified'), JobScopeInventoryItemTypeProto.DEFAULT, 'Default'), JobScopeInventoryItemTypeProto.BOOKKEEPING, 'Bookkeeping'), JobScopeInventoryItemTypeProto.CONSULTATION, 'Consultation');
var ScopeChangeRequest = (_class = /*#__PURE__*/function (_Model) {
  function ScopeChangeRequest() {
    var _this;
    _classCallCheck(this, ScopeChangeRequest);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScopeChangeRequest, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor2, _this);
    _initializerDefineProperty(_this, "status", _descriptor3, _this);
    _initializerDefineProperty(_this, "jobId", _descriptor4, _this);
    _initializerDefineProperty(_this, "createdByUserPublicId", _descriptor5, _this);
    _initializerDefineProperty(_this, "items", _descriptor6, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor7, _this);
    return _this;
  }
  _inherits(ScopeChangeRequest, _Model);
  return _createClass(ScopeChangeRequest, [{
    key: "isAccepted",
    get: function get() {
      return this.status === 'Accepted';
    }
  }, {
    key: "isRejected",
    get: function get() {
      return this.status === 'Rejected';
    }
  }, {
    key: "isApplyFailed",
    get: function get() {
      return this.status === 'ApplyFailed';
    }
  }, {
    key: "isPending",
    get: function get() {
      return !this.isAccepted && !this.isRejected;
    }
  }, {
    key: "isPendingClientApproval",
    get: function get() {
      return this.status === 'PendingClientApproval';
    }
  }, {
    key: "isAdminApproved",
    get: function get() {
      return this.status !== 'PendingFinalization' && this.status !== 'PendingAdminApproval';
    }

    /**
     * Parses the DTO to model properties.
     */
  }, {
    key: "parse",
    value: function parse(attrs) {
      return {
        id: attrs.id,
        workspaceId: attrs.workspaceId,
        status: ScopeChangeStatus[attrs.status],
        jobId: attrs.jobId,
        createdByUserPublicId: attrs.createdByUserPublicId,
        createdBy: attrs.createdByUserPublicId && this.rootStore.memberStore.setAndFetchByPublicId({
          user_public_id: attrs.createdByUserPublicId,
          workspace_id: attrs.workspaceId
        }),
        items: attrs.itemsList && attrs.itemsList.map(function (item) {
          return new ScopeChangeRequestItem({
            id: item.id,
            name: item.name,
            quantity: item.quantity,
            inventoryItemId: item.inventoryItemId === null ? null : item.inventoryItemId ? item.inventoryItemId.value : undefined,
            inventoryItemVersionId: item.inventoryItemVersionId === null ? null : item.inventoryItemVersionId ? item.inventoryItemVersionId.value : undefined,
            inventoryItemType: JobScopeInventoryItemType[item.inventoryItemType]
          });
        }),
        dateCreated: maybeParseDate(timestampToISO(attrs.createTime))
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "createdByUserPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "items", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isAccepted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAccepted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRejected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRejected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isApplyFailed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isApplyFailed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPending", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPendingClientApproval", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPendingClientApproval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAdminApproved", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAdminApproved"), _class.prototype), _class);
export { ScopeChangeRequest as default };
//# sourceMappingURL=ScopeChangeRequest.js.map
